// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price-payment-card-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px;
}
.price-payment-card-wrapper .price-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  padding: 12px;
  padding-top: 6px;
  cursor: pointer;
}
.price-payment-card-wrapper .price-details-header span {
  font-size: 20px;
  font-weight: 600;
  color: #000;
}
.price-payment-card-wrapper .price-details-header span.open {
  transform: rotate(-90deg);
}
.price-payment-card-wrapper .price-details-header span.close {
  transform: rotate(180deg);
}
.price-payment-card-wrapper .price-detail-row-wrapper {
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 12px;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper {
  display: flex;
  justify-content: space-between;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .cabin-fare-details,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .cabin-fare-details {
  font-weight: 700;
  font-size: 16px;
  color: #525252;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .port-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .port-amount,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .service-tax-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .service-tax-amount,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .discount-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .discount-amount,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .discount-title,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .applied-coupon-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .applied-coupon-code,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .gst-details,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .service-tax-details,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .port-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .port-amount,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .service-tax-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .service-tax-amount,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .discount-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .discount-amount,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .discount-title,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .applied-coupon-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .applied-coupon-code,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .gst-details,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .service-tax-details {
  font-weight: 400;
  font-size: 14px;
  color: #4d4d4d;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .port-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .port-amount,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .port-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .port-amount {
  font-size: 12px;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .discount-text, .price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .discount-amount, .price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .discount-title,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .discount-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .discount-amount,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .discount-title {
  color: #04A515;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .applied-coupon-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .applied-coupon-text {
  font-style: italic;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .common-row-wrapper .applied-coupon-code,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .common-row-wrapper .applied-coupon-code {
  font-weight: 600;
  color: #93288E;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .coupon-code-wrapper div,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .coupon-code-wrapper div {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .coupon-code-wrapper div .remove-text,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .coupon-code-wrapper div .remove-text {
  font-size: 10px;
  font-weight: 500;
  color: #008CFF;
  cursor: pointer;
}
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-cabins .ssr-fare-details,
.price-payment-card-wrapper .price-detail-row-wrapper .price-detail-row-wrapper-ssrs .ssr-fare-details {
  font-weight: 700;
  font-size: 16px;
  color: #525252;
  text-transform: capitalize;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #ddd;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total .total-amount-text {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total .total-amount-price-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 6px;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total .total-amount-price-wrapper .strikethrough-price-wrapper {
  position: relative;
  padding-bottom: 3px;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total .total-amount-price-wrapper .strikethrough-price-wrapper .striked-price {
  font-size: 16px;
  font-weight: 500;
  color: #525252;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total .total-amount-price-wrapper .strikethrough-price-wrapper .strike {
  width: 100%;
  height: 1px;
  position: absolute;
  background-color: #DE7B83;
  bottom: 50%;
  transform: rotate(-7deg);
}
.price-payment-card-wrapper .price-detail-row-wrapper-total .total-amount-price-wrapper .total-amount-price {
  font-size: 24px;
  font-weight: 700;
  color: #93288E;
  display: flex;
  gap: 10px;
  align-items: center;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total .total-amount-price-wrapper .total-amount-price .paid-text {
  font-size: 20px;
  font-weight: 600;
  color: #4a943a;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total.border-top {
  border-top: 1px solid #ddd;
}
.price-payment-card-wrapper .price-detail-row-wrapper-total.drop-bb {
  border-bottom: none;
  padding-bottom: 4px;
}
.price-payment-card-wrapper .booking-details-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.price-payment-card-wrapper .booking-details-wrapper.no-bb {
  border-bottom: none;
  padding-bottom: 0;
}
.price-payment-card-wrapper .booking-details-wrapper div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.price-payment-card-wrapper .booking-details-wrapper div .left-text-booking-number,
.price-payment-card-wrapper .booking-details-wrapper div .left-text-amount {
  text-align: left;
}
.price-payment-card-wrapper .booking-details-wrapper div .right-text-booking-number,
.price-payment-card-wrapper .booking-details-wrapper div .right-text-amount {
  text-align: right;
}
.price-payment-card-wrapper .booking-details-wrapper div .left-text-booking-number, .price-payment-card-wrapper .booking-details-wrapper div .right-text-booking-number {
  font-size: 15px;
  font-weight: 600;
}
.price-payment-card-wrapper .booking-details-wrapper div .left-text-amount, .price-payment-card-wrapper .booking-details-wrapper div .right-text-amount {
  font-size: 17px;
  font-weight: 600;
}
.price-payment-card-wrapper .payment-options-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.price-payment-card-wrapper .payment-options-header:hover {
  background: #F6F9FF;
}
.price-payment-card-wrapper .payment-options-header span {
  font-size: 22px;
  font-weight: 600;
  color: #008CFF;
}
.price-payment-card-wrapper .payment-options-header span.open {
  transform: rotate(-90deg);
}
.price-payment-card-wrapper .payment-options-header span.close {
  transform: rotate(180deg);
}
.price-payment-card-wrapper .payment-options-header.border-bottom {
  border-bottom: 1px solid #ddd;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.price-payment-card-wrapper .payment-options-button-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  padding: 12px;
}
.price-payment-card-wrapper .payment-options-button-wrapper button {
  width: 100%;
  padding: 12px 0;
  border-radius: 6px;
  font-weight: 500;
  border: 1px solid #ddd;
}
.price-payment-card-wrapper .payment-options-button-wrapper button.active {
  background-color: #93288E;
  color: #fff;
}
.price-payment-card-wrapper .payment-options-button-wrapper.border-bottom {
  border-bottom: 1px solid #ddd;
}
.price-payment-card-wrapper .single-payment-wrapper,
.price-payment-card-wrapper .split-payment-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 12px;
  cursor: pointer;
}
.price-payment-card-wrapper .single-payment-wrapper:hover,
.price-payment-card-wrapper .split-payment-wrapper:hover {
  background: rgba(147, 40, 142, 0.0588235294);
}
.price-payment-card-wrapper .single-payment-wrapper .body-wrapper,
.price-payment-card-wrapper .split-payment-wrapper .body-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}
.price-payment-card-wrapper .single-payment-wrapper .body-wrapper .text-wrapper,
.price-payment-card-wrapper .split-payment-wrapper .body-wrapper .text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.price-payment-card-wrapper .single-payment-wrapper .body-wrapper .text-wrapper .main-text,
.price-payment-card-wrapper .split-payment-wrapper .body-wrapper .text-wrapper .main-text {
  font-size: 20px;
  font-weight: 700;
  color: #000;
}
.price-payment-card-wrapper .single-payment-wrapper .body-wrapper .text-wrapper .secondary-text,
.price-payment-card-wrapper .split-payment-wrapper .body-wrapper .text-wrapper .secondary-text {
  font-size: 14px;
  font-weight: 500;
  color: #7a7a7a;
}
.price-payment-card-wrapper .single-payment-wrapper span,
.price-payment-card-wrapper .split-payment-wrapper span {
  font-size: 22px;
  font-weight: 600;
  color: #000;
}
.price-payment-card-wrapper .single-payment-wrapper span.open,
.price-payment-card-wrapper .split-payment-wrapper span.open {
  transform: rotate(-90deg);
}
.price-payment-card-wrapper .single-payment-wrapper span.close,
.price-payment-card-wrapper .split-payment-wrapper span.close {
  transform: rotate(180deg);
}
.price-payment-card-wrapper .single-payment-wrapper.bg-single-payment, .price-payment-card-wrapper .single-payment-wrapper.bg-split-payment,
.price-payment-card-wrapper .split-payment-wrapper.bg-single-payment,
.price-payment-card-wrapper .split-payment-wrapper.bg-split-payment {
  background: rgba(147, 40, 142, 0.0588235294);
}
.price-payment-card-wrapper .split-payment-wrapper {
  border-top: 1px solid #ddd;
}
.price-payment-card-wrapper .split-payment-cards-wrapper {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  margin-left: 58px;
  padding: 26px 0;
}
.price-payment-card-wrapper .split-payment-cards-wrapper .split-payment-card-wrapper {
  min-width: 210px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
}
.price-payment-card-wrapper .split-payment-cards-wrapper .split-payment-card-wrapper.active {
  background: rgba(147, 40, 142, 0.0588235294);
  border: 1px solid #93288E;
}
.price-payment-card-wrapper .split-payment-cards-wrapper .split-payment-card-wrapper.inactive {
  background: #fffefe;
}
.price-payment-card-wrapper .split-payment-cards-wrapper .split-payment-card-wrapper.inactive span {
  color: #8d8d8d;
}
.price-payment-card-wrapper .split-payment-cards-wrapper .split-payment-card-wrapper .main-text {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}
.price-payment-card-wrapper .split-payment-cards-wrapper .split-payment-card-wrapper .secondary-text {
  font-size: 12px;
  font-weight: 500;
  color: #666362;
  margin-bottom: 4px;
}
.price-payment-card-wrapper .split-payment-cards-wrapper .split-payment-card-wrapper .amount-text {
  font-size: 26px;
  font-weight: 700;
  color: #93288E;
}
.price-payment-card-wrapper .custom-payment-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 58px;
  margin-bottom: 20px;
}
.price-payment-card-wrapper .custom-payment-input-wrapper div:first-child {
  display: flex;
  flex-direction: column;
}
.price-payment-card-wrapper .custom-payment-input-wrapper div:first-child span:first-child {
  font-size: 20px;
  font-weight: 400;
  color: #000;
  margin-bottom: 0;
}
.price-payment-card-wrapper .custom-payment-input-wrapper div:first-child span:last-child {
  font-size: 12px;
}
.price-payment-card-wrapper .custom-payment-input-wrapper .custom-payment-input-row {
  display: flex;
  gap: 14px;
  align-items: center;
  position: relative;
}
.price-payment-card-wrapper .custom-payment-input-wrapper .custom-payment-input-row span,
.price-payment-card-wrapper .custom-payment-input-wrapper .custom-payment-input-row input {
  font-size: 28px;
  color: #000;
}
.price-payment-card-wrapper .custom-payment-input-wrapper .custom-payment-input-row input {
  padding-left: 20px;
  border-bottom: 1px solid #aaa;
  font-weight: 700;
  letter-spacing: 0.02em;
  width: 60%;
}
.price-payment-card-wrapper .custom-payment-input-wrapper .custom-payment-input-row input:focus-visible {
  outline: none;
}
.price-payment-card-wrapper .custom-payment-input-wrapper .custom-payment-input-row .rupee-abs {
  position: absolute;
  left: 0;
}
.price-payment-card-wrapper .custom-payment-input-wrapper .custom-payment-input-row button {
  border-radius: 4px;
  padding: 8px 16px;
  background-color: #93288E;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
}
.price-payment-card-wrapper .custom-payment-input-wrapper .custom-payment-input-row button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media only screen and (768px < width <= 1024px) {
  .price-payment-card-wrapper .payment-options-button-wrapper {
    flex-wrap: wrap;
  }
}
@media only screen and (width <= 370px) {
  .split-payment-cards-wrapper {
    margin: 0 !important;
    justify-content: center;
  }
  .price-payment-card-wrapper .custom-payment-input-wrapper {
    margin: 0;
  }
}
@media only screen and (width <= 476px) {
  .price-payment-card-wrapper .payment-options-button-wrapper {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/PricePaymentCard/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AACR;AACQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AACZ;AACY;EACI,yBAAA;AAChB;AAEY;EACI,yBAAA;AAAhB;AAKI;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EAEA,SAAA;AAJR;AAMQ;;EAEI,aAAA;EACA,sBAAA;EACA,QAAA;AAJZ;AAMY;;EACI,aAAA;EACA,8BAAA;AAHhB;AAKgB;;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAFpB;AAKgB;;;;;;;;;;;;;;;;;;;;;;EAWI,gBAAA;EACA,eAAA;EACA,cAAA;AAQpB;AALgB;;;;EAEI,eAAA;AASpB;AANgB;;;;EACI,cAAA;AAWpB;AARgB;;EACI,kBAAA;AAWpB;AARgB;;EACI,gBAAA;EACA,cAAA;AAWpB;AANgB;;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;AASpB;AAPoB;;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAUxB;AALY;;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;AAQhB;AAHI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;AAKR;AAHQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAKZ;AAFQ;EACI,aAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,QAAA;AAIZ;AAFY;EACI,kBAAA;EACA,mBAAA;AAIhB;AAFgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAIpB;AADgB;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;AAGpB;AACY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAChB;AACgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AACpB;AAIQ;EACI,0BAAA;AAFZ;AAKQ;EACI,mBAAA;EACA,mBAAA;AAHZ;AAOI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,0BAAA;EACA,6BAAA;AALR;AAOQ;EACI,mBAAA;EACA,iBAAA;AALZ;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AALZ;AAOY;;EAEI,gBAAA;AALhB;AAQY;;EAEI,iBAAA;AANhB;AASY;EACI,eAAA;EACA,gBAAA;AAPhB;AAUY;EACI,eAAA;EACA,gBAAA;AARhB;AAaI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,+BAAA;AAXR;AAaQ;EACI,mBAAA;AAXZ;AAcQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAZZ;AAcY;EACI,yBAAA;AAZhB;AAeY;EACI,yBAAA;AAbhB;AAiBQ;EACI,6BAAA;EACA,8BAAA;EACA,+BAAA;AAfZ;AAoBI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;AAlBR;AAoBQ;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAlBZ;AAoBY;EACI,yBAAA;EACA,WAAA;AAlBhB;AAsBQ;EACI,6BAAA;AApBZ;AAwBI;;EAEI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAtBR;AAwBQ;;EACI,4CAAA;AArBZ;AAwBQ;;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AArBZ;AAuBY;;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AApBhB;AAsBgB;;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAnBpB;AAsBgB;;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAnBpB;AAwBQ;;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AArBZ;AAuBY;;EACI,yBAAA;AApBhB;AAuBY;;EACI,yBAAA;AApBhB;AAwBQ;;;EAEI,4CAAA;AArBZ;AAyBI;EACI,0BAAA;AAvBR;AA0BI;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAxBR;AA0BQ;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAxBZ;AA0BY;EACI,4CAAA;EACA,yBAAA;AAxBhB;AA2BY;EACI,mBAAA;AAzBhB;AA2BgB;EACI,cAAA;AAzBpB;AA6BY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AA3BhB;AA8BY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA5BhB;AA+BY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AA7BhB;AAkCI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AAhCR;AAkCQ;EACI,aAAA;EACA,sBAAA;AAhCZ;AAkCY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAhChB;AAmCY;EACI,eAAA;AAjChB;AAqCQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAnCZ;AAqCY;;EAEI,eAAA;EACA,WAAA;AAnChB;AAsCY;EACI,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;AApChB;AAsCgB;EACI,aAAA;AApCpB;AAwCY;EACI,kBAAA;EACA,OAAA;AAtChB;AAyCY;EACI,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAvChB;AAyCgB;EACI,YAAA;EACA,mBAAA;AAvCpB;;AA8CA;EAEQ;IACI,eAAA;EA5CV;AACF;AAgDA;EACI;IACI,oBAAA;IACA,uBAAA;EA9CN;EAkDM;IACI,SAAA;EAhDV;AACF;AAoDA;EAEQ;IACI,eAAA;EAnDV;AACF","sourcesContent":[".price-payment-card-wrapper {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px;\n\n    .price-details-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-bottom: 1px solid #ddd;\n        border-top-left-radius: 6px;\n        border-top-right-radius: 6px;\n        padding: 12px;\n        padding-top: 6px;\n        cursor: pointer;\n\n        span {\n            font-size: 20px;\n            font-weight: 600;\n            color: #000;\n\n            &.open {\n                transform: rotate(-90deg);\n            }\n\n            &.close {\n                transform: rotate(180deg);\n            }\n        }\n    }\n\n    .price-detail-row-wrapper {\n        display: flex;\n        flex-direction: column;\n        padding: 12px;\n        ;\n        gap: 12px;\n\n        .price-detail-row-wrapper-cabins,\n        .price-detail-row-wrapper-ssrs {\n            display: flex;\n            flex-direction: column;\n            gap: 4px;\n\n            .common-row-wrapper {\n                display: flex;\n                justify-content: space-between;\n\n                .cabin-fare-details {\n                    font-weight: 700;\n                    font-size: 16px;\n                    color: #525252;\n                }\n\n                .port-text,\n                .port-amount,\n                .service-tax-text,\n                .service-tax-amount,\n                .discount-text,\n                .discount-amount,\n                .discount-title,\n                .applied-coupon-text,\n                .applied-coupon-code,\n                .gst-details,\n                .service-tax-details {\n                    font-weight: 400;\n                    font-size: 14px;\n                    color: #4d4d4d;\n                }\n\n                .port-text,\n                .port-amount{\n                    font-size: 12px;\n                }\n\n                .discount-text, .discount-amount, .discount-title {\n                    color: #04A515;\n                }\n\n                .applied-coupon-text {\n                    font-style: italic;\n                }\n\n                .applied-coupon-code {\n                    font-weight: 600;\n                    color: #93288E;\n                }\n            }\n\n            .coupon-code-wrapper {\n                div {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: flex-end;\n\n                    .remove-text {\n                        font-size: 10px;\n                        font-weight: 500;\n                        color: #008CFF;\n                        cursor: pointer;\n                    }\n                }\n            }\n\n            .ssr-fare-details {\n                font-weight: 700;\n                font-size: 16px;\n                color: #525252;\n                text-transform: capitalize;\n            }\n        }\n    }\n\n    .price-detail-row-wrapper-total {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 12px;\n        border-bottom: 1px solid #ddd;\n\n        .total-amount-text {\n            font-size: 18px;\n            font-weight: 600;\n            color: #000;\n        }\n\n        .total-amount-price-wrapper {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: flex-end;\n            justify-content: flex-end;\n            gap: 6px;\n\n            .strikethrough-price-wrapper {\n                position: relative;\n                padding-bottom: 3px;\n\n                .striked-price {\n                    font-size: 16px;\n                    font-weight: 500;\n                    color: #525252;\n                }\n\n                .strike {\n                    width: 100%;\n                    height: 1px;\n                    position: absolute;\n                    background-color: #DE7B83;\n                    bottom: 50%;\n                    transform: rotate(-7deg);\n                }\n            }\n\n            .total-amount-price {\n                font-size: 24px;\n                font-weight: 700;\n                color: #93288E;\n                display: flex;\n                gap: 10px;\n                align-items: center;\n\n                .paid-text {\n                    font-size: 20px;\n                    font-weight: 600;\n                    color: #4a943a;\n                }\n            }\n        }\n\n        &.border-top {\n            border-top: 1px solid #ddd;\n        }\n\n        &.drop-bb{\n            border-bottom: none;\n            padding-bottom: 4px;\n        }\n    }\n\n    .booking-details-wrapper{\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        padding: 12px;\n        border-top: 1px solid #ddd;\n        border-bottom: 1px solid #ddd;\n\n        &.no-bb{\n            border-bottom: none;\n            padding-bottom: 0;\n        }\n        div{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n\n            .left-text-booking-number,\n            .left-text-amount{\n                text-align: left;\n            }\n\n            .right-text-booking-number,\n            .right-text-amount{\n                text-align: right;\n            }\n\n            .left-text-booking-number, .right-text-booking-number{\n                font-size: 15px;\n                font-weight: 600;\n            }\n\n            .left-text-amount, .right-text-amount{\n                font-size: 17px;\n                font-weight: 600;\n            }\n        }\n    }\n\n    .payment-options-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 12px;\n        cursor: pointer;\n        border-bottom-left-radius: 6px;\n        border-bottom-right-radius: 6px;\n\n        &:hover {\n            background: #F6F9FF;\n        }\n\n        span {\n            font-size: 22px;\n            font-weight: 600;\n            color: #008CFF;\n\n            &.open {\n                transform: rotate(-90deg);\n            }\n\n            &.close {\n                transform: rotate(180deg);\n            }\n        }\n\n        &.border-bottom {\n            border-bottom: 1px solid #ddd;\n            border-bottom-left-radius: 0px;\n            border-bottom-right-radius: 0px;\n            // padding-bottom: 12px;   \n        }\n    }\n\n    .payment-options-button-wrapper{\n        display: flex;\n        justify-content: space-between;\n        gap: 12px;\n        align-items: center;\n        padding: 12px;\n        \n        button{\n            width: 100%;\n            padding: 12px 0;\n            border-radius: 6px;\n            font-weight: 500;\n            border: 1px solid #ddd;\n            \n            &.active{\n                background-color: #93288E;\n                color: #fff;\n            }\n        }\n\n        &.border-bottom {\n            border-bottom: 1px solid #ddd;\n        }\n    }\n\n    .single-payment-wrapper,\n    .split-payment-wrapper {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 16px 12px;\n        cursor: pointer;\n\n        &:hover {\n            background: #93288E0F;\n        }\n\n        .body-wrapper {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n\n            .text-wrapper {\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n\n                .main-text {\n                    font-size: 20px;\n                    font-weight: 700;\n                    color: #000;\n                }\n\n                .secondary-text {\n                    font-size: 14px;\n                    font-weight: 500;\n                    color: #7a7a7a;\n                }\n            }\n        }\n\n        span {\n            font-size: 22px;\n            font-weight: 600;\n            color: #000;\n\n            &.open {\n                transform: rotate(-90deg);\n            }\n\n            &.close {\n                transform: rotate(180deg);\n            }\n        }\n\n        &.bg-single-payment,\n        &.bg-split-payment {\n            background: #93288E0F;\n        }\n    }\n\n    .split-payment-wrapper {\n        border-top: 1px solid #ddd;\n    }\n\n    .split-payment-cards-wrapper {\n        display: flex;\n        gap: 18px;\n        flex-wrap: wrap;\n        margin-left: 58px;\n        padding: 26px 0;\n\n        .split-payment-card-wrapper {\n            min-width: 210px;\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 8px;\n            padding: 8px 12px;\n            border-radius: 6px;\n            cursor: pointer;\n\n            &.active {\n                background: #93288E0F;\n                border: 1px solid #93288E;\n            }\n\n            &.inactive {\n                background: #fffefe;\n\n                span {\n                    color: #8d8d8d;\n                }\n            }\n\n            .main-text {\n                font-size: 18px;\n                font-weight: 600;\n                color: #000;\n            }\n\n            .secondary-text {\n                font-size: 12px;\n                font-weight: 500;\n                color: #666362;\n                margin-bottom: 4px;\n            }\n\n            .amount-text {\n                font-size: 26px;\n                font-weight: 700;\n                color: #93288E;\n            }\n        }\n    }\n\n    .custom-payment-input-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n        margin-left: 58px;\n        margin-bottom: 20px;\n\n        div:first-child {\n            display: flex;\n            flex-direction: column;\n\n            span:first-child {\n                font-size: 20px;\n                font-weight: 400;\n                color: #000;\n                margin-bottom: 0;\n            }\n\n            span:last-child{\n                font-size: 12px;\n            }\n        }\n\n        .custom-payment-input-row {\n            display: flex;\n            gap: 14px;\n            align-items: center;\n            position: relative;\n\n            span,\n            input {\n                font-size: 28px;\n                color: #000;\n            }\n\n            input {\n                padding-left: 20px;\n                border-bottom: 1px solid #aaa;\n                font-weight: 700;\n                letter-spacing: 0.02em;\n                width: 60%;\n\n                &:focus-visible {\n                    outline: none;\n                }\n            }\n\n            .rupee-abs {\n                position: absolute;\n                left: 0;\n            }\n\n            button{\n                border-radius: 4px;\n                padding: 8px 16px;\n                background-color: #93288E;\n                color: #fff;\n                cursor: pointer;\n                white-space: nowrap;\n\n                &.disabled{\n                    opacity: 0.6;\n                    cursor: not-allowed;\n                }\n            }\n        }    \n    }\n}\n\n@media only screen and (768px < width <= 1024px) {\n    .price-payment-card-wrapper{\n        .payment-options-button-wrapper{\n            flex-wrap: wrap;\n        }\n    }\n}\n\n@media only screen and (width <= 370px) {\n    .split-payment-cards-wrapper{\n        margin: 0!important;\n        justify-content: center;\n    }\n\n    .price-payment-card-wrapper{\n        .custom-payment-input-wrapper{\n            margin: 0;\n        }\n    }\n}\n\n@media only screen and (width <= 476px) {\n    .price-payment-card-wrapper{\n        .payment-options-button-wrapper{\n            flex-wrap: wrap;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
